import $ from 'jquery';
window.jQuery = $;
window.$ = $;

import 'lazysizes';
import 'lazysizes/plugins/parent-fit/ls.parent-fit';
import 'lazysizes/plugins/object-fit/ls.object-fit';

import Headroom from 'headroom.js/dist/headroom.js';
window.Headroom = Headroom;

import sal from 'sal.js'
import Swiper from 'swiper';
import { Navigation, Autoplay } from 'swiper/modules';

import { windowWatcher } from './components/window-watcher';
import { nav } from './components/nav';
import { news } from './components/news';
import { projects } from './components/projects';
import { anchorLinks } from './components/anchor-links';
import { collapsibleSections } from './components/collapsible-sections';
import { toggleSections } from './components/toggle-sections';
import { toggleView } from "./components/toggle-view";
import { map } from './components/map';
import { header } from './components/header';
import { initHeadingAnimations, initCardAnimations } from './components/animations';
// import './components/carousel';

window.main = window.main || {};

const $body = $('body');

let isHomepage = false;
let isTouchDevice = false;

main.init = () => {

  sal({
    threshold: 0.01
  });

  function checkIfTouchDevice(){
    return true == ("ontouchstart" in window || window.DocumentTouch && document instanceof DocumentTouch);
  }

  if(checkIfTouchDevice() === true) {
    $body.addClass('is-touch');
    $body.addClass('is-mobile-device');
    isTouchDevice = true;
  }
  else {
    isTouchDevice = false;
  }

  if($body.hasClass('page--is-homepage')) {
    isHomepage = true;
  }

  windowWatcher();
  nav(isHomepage,isTouchDevice);
  anchorLinks();
  collapsibleSections();
  toggleSections();
  toggleView();
  map('.js-map');
  news();
  projects();
  header();
  initHeadingAnimations();
  initCardAnimations();

  // Initialize Swiper
  const swiper = new Swiper('.js-slick-carousel', {
    modules: [Navigation],
    slidesPerView: 1,
    spaceBetween: 32,
    navigation: {
      nextEl: '.c-carousel__nav--next',
      prevEl: '.c-carousel__nav--prev',
    },
    breakpoints: {
      600: {
        slidesPerView: 2,
      },
      960: {
        slidesPerView: 3,
      }
    },
    on: {
      slideChange: function () {
        const progressBars = this.el.closest('.c-carousel').querySelectorAll('.c-carousel__progress-bar');
        const totalSlides = this.slides.length;
        const slidesPerView = this.params.slidesPerView;
        const totalSteps = totalSlides - slidesPerView + 1;
        
        // Calculate which step we're on (0-based)
        const currentStep = this.activeIndex;
        
        // Update the active segment
        progressBars.forEach((bar, index) => {
          bar.classList.toggle('is-active', index === currentStep);
        });
      },
      init: function () {
        const progressBars = this.el.closest('.c-carousel').querySelectorAll('.c-carousel__progress-bar');
        progressBars[0].classList.add('is-active');
      }
    }
  });

  // Initialize Highlights Carousel
  const highlightsSwiper = new Swiper('.js-highlights-carousel', {
    modules: [Navigation],
    slidesPerView: 1,
    spaceBetween: 32,
    loop: true,
    speed: 800,
    navigation: {
      nextEl: '.js-highlights-next',
      prevEl: '.js-highlights-prev',
    },
    breakpoints: {
      480: {
        slidesPerView: 2,
      },
      960: {
        slidesPerView: 3,
      }
    },
    on: {
      slideChange: function () {
        const progressBars = this.el.closest('.c-carousel').querySelectorAll('.c-carousel__progress-bar');
        const totalSlides = this.slides.length;
        const slidesPerView = this.params.slidesPerView;
        const totalSteps = totalSlides - slidesPerView + 1;
        
        // Get the real index (accounting for loop)
        const realIndex = this.realIndex;
        
        // Calculate which step we're on (0-based)
        let currentStep = realIndex;
        
        // If we're at the end, reset to 0
        if (currentStep >= totalSteps) {
          currentStep = 0;
        }
        
        // Update the active segment
        progressBars.forEach((bar, index) => {
          bar.classList.toggle('is-active', index === currentStep);
        });
      },
      init: function () {
        const progressBars = this.el.closest('.c-carousel').querySelectorAll('.c-carousel__progress-bar');
        progressBars[0].classList.add('is-active');
      },
      resize: function () {
        // Recalculate progress bars on resize
        const progressBars = this.el.closest('.c-carousel').querySelectorAll('.c-carousel__progress-bar');
        const totalSlides = this.slides.length;
        const slidesPerView = this.params.slidesPerView;
        const totalSteps = totalSlides - slidesPerView + 1;
        
        // Update progress bars count if needed
        if (progressBars.length !== totalSteps) {
          const container = progressBars[0].parentElement;
          container.innerHTML = '';
          for (let i = 0; i < totalSteps; i++) {
            const bar = document.createElement('div');
            bar.className = 'c-carousel__progress-bar' + (i === 0 ? ' is-active' : '');
            container.appendChild(bar);
          }
        }
      }
    }
  });

  // Initialize Projects Carousel
  const projectsSwiper = new Swiper('.js-projects-carousel', {
    modules: [Navigation, Autoplay],
    slidesPerView: 1,
    spaceBetween: 32,
    loop: true,
    speed: 800,
    autoplay: {
      delay: 3000,
      disableOnInteraction: false,
    },
    navigation: {
      nextEl: '.js-projects-next',
      prevEl: '.js-projects-prev',
    },
    breakpoints: {
      480: {
        slidesPerView: 2,
      },
      960: {
        slidesPerView: 3,
      }
    },
    on: {
      slideChange: function () {
        const progressBars = this.el.closest('.c-carousel').querySelectorAll('.c-carousel__progress-bar');
        const totalSlides = this.slides.length;
        const slidesPerView = this.params.slidesPerView;
        const totalSteps = totalSlides - slidesPerView + 1;
        
        // Get the real index (accounting for loop)
        const realIndex = this.realIndex;
        
        // Calculate which step we're on (0-based)
        let currentStep = realIndex;
        
        // If we're at the end, reset to 0
        if (currentStep >= totalSteps) {
          currentStep = 0;
        }
        
        // Update the active segment
        progressBars.forEach((bar, index) => {
          bar.classList.toggle('is-active', index === currentStep);
        });
      },
      init: function () {
        const progressBars = this.el.closest('.c-carousel').querySelectorAll('.c-carousel__progress-bar');
        progressBars[0].classList.add('is-active');
      },
      resize: function () {
        // Recalculate progress bars on resize
        const progressBars = this.el.closest('.c-carousel').querySelectorAll('.c-carousel__progress-bar');
        const totalSlides = this.slides.length;
        const slidesPerView = this.params.slidesPerView;
        const totalSteps = totalSlides - slidesPerView + 1;
        
        // Update progress bars count if needed
        if (progressBars.length !== totalSteps) {
          const container = progressBars[0].parentElement;
          container.innerHTML = '';
          for (let i = 0; i < totalSteps; i++) {
            const bar = document.createElement('div');
            bar.className = 'c-carousel__progress-bar' + (i === 0 ? ' is-active' : '');
            container.appendChild(bar);
          }
        }
      }
    }
  });
};

$(main.init);
